import React from "react";
import { Box, Typography } from "@mui/material";

/**
 * Sliding two-option toggle: a pill whose thumb travels left/right. Used to
 * switch an image panel between two views (e.g. the source and a rendered
 * preview). ``options`` are exactly two ``{ value, label }`` entries.
 */
export default function PreviewToggle({ value, onChange, options, ariaLabel = "Preview view", width = 340 }) {
  const [first, second] = options;
  return (
    <Box
      role="tablist"
      aria-label={ariaLabel}
      sx={{
        position: "relative",
        display: "inline-grid",
        gridTemplateColumns: "1fr 1fr",
        p: "4px",
        borderRadius: 999,
        bgcolor: "grey.200",
        width,
        maxWidth: "100%",
        userSelect: "none",
      }}
    >
      <Box
        sx={{
          position: "absolute",
          top: 4,
          bottom: 4,
          left: 4,
          width: "calc(50% - 4px)",
          borderRadius: 999,
          bgcolor: "background.paper",
          boxShadow: "0 1px 4px rgba(15, 23, 42, 0.25)",
          transform: value === second.value ? "translateX(100%)" : "translateX(0)",
          transition: "transform 200ms ease",
        }}
      />
      {[first, second].map((option) => (
        <Box
          key={option.value}
          role="tab"
          tabIndex={0}
          aria-selected={value === option.value}
          onClick={() => onChange(option.value)}
          onKeyDown={(event) => {
            if (event.key === "Enter" || event.key === " ") onChange(option.value);
          }}
          sx={{
            position: "relative", zIndex: 1, textAlign: "center",
            py: 0.75, px: 1, borderRadius: 999, cursor: "pointer",
          }}
        >
          <Typography
            variant="body2"
            sx={{
              fontWeight: value === option.value ? 700 : 500,
              color: value === option.value ? "text.primary" : "text.secondary",
              whiteSpace: "nowrap",
            }}
          >
            {option.label}
          </Typography>
        </Box>
      ))}
    </Box>
  );
}
